import * as angular from "angular";
import {IController} from "angular";

export class BringozTablePaginationButtonsComponent implements IController {
  isBackDisabled: any;
  isNextDisabled: any;
  onBack: Function;
  onNext: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTablePaginationButtons', {
    bindings: {
      isBackDisabled: '<',
      isNextDisabled: '<',
      onBack: '&',
      onNext: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-table-pagination-buttons/bringoz-table-pagination-buttons.html',
    controller: BringozTablePaginationButtonsComponent
  });
